import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';

const Reports = () => {
  const { activeTenant } = useTenant();
  const [period, setPeriod] = useState('');
  const [summary, setSummary] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [ledger, setLedger] = useState([]);

  const loadSummary = async () => {
    if (!period) {
      toast.error('Selecciona un periodo');
      return;
    }
    try {
      const res = await api.get(`/reports/monthly?tenant_id=${activeTenant}&period=${period}`);
      setSummary(res.data);
    } catch (error) {
      toast.error('Error al cargar resumen');
    }
  };

  const loadLedger = async () => {
    if (!fromDate || !toDate) {
      toast.error('Selecciona rango');
      return;
    }
    try {
      const res = await api.get(`/reports/ledger?tenant_id=${activeTenant}&from_date=${fromDate}&to_date=${toDate}`);
      setLedger(res.data.entries || []);
    } catch (error) {
      toast.error('Error al cargar libro diario');
    }
  };

  const downloadReport = (type, format) => {
    let url = `${process.env.REACT_APP_BACKEND_URL}/api/reports/${type}/export?tenant_id=${activeTenant}&format=${format}`;
    if (type === 'monthly') {
      url += `&period=${period}`;
    } else {
      url += `&from_date=${fromDate}&to_date=${toDate}`;
    }
    window.location.assign(url);
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6" data-testid="client-reports-page">
      <div>
        <h1 className="text-4xl font-heading font-bold">Reportes</h1>
        <p className="text-muted-foreground">Resumen mensual y libro diario.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Resumen mensual</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-wrap items-end gap-3">
            <div>
              <Label>Periodo</Label>
              <Input type="month" value={period} onChange={(e) => setPeriod(e.target.value)} />
            </div>
            <Button onClick={loadSummary}>Cargar</Button>
            <Button variant="outline" onClick={() => downloadReport('monthly', 'csv')}>CSV</Button>
            <Button variant="outline" onClick={() => downloadReport('monthly', 'pdf')}>PDF</Button>
          </div>
          {summary && (
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-sm">
              <div>Total facturado: {summary.total_invoiced}</div>
              <div>Total gastos: {summary.total_expenses}</div>
              <div>IVA repercutido: {summary.vat_payable}</div>
              <div>IVA soportado: {summary.vat_recoverable}</div>
              <div>Neto: {summary.net}</div>
            </div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Libro diario</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-wrap items-end gap-3">
            <div>
              <Label>Desde</Label>
              <Input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
            </div>
            <div>
              <Label>Hasta</Label>
              <Input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
            </div>
            <Button onClick={loadLedger}>Cargar</Button>
            <Button variant="outline" onClick={() => downloadReport('ledger', 'csv')}>CSV</Button>
            <Button variant="outline" onClick={() => downloadReport('ledger', 'pdf')}>PDF</Button>
          </div>
          <div className="border rounded-lg overflow-x-auto">
            {ledger.length === 0 ? (
              <div className="px-6 py-6 text-sm text-muted-foreground">Sin entradas.</div>
            ) : (
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="text-left border-b">
                    <th className="p-2">Fecha</th>
                    <th className="p-2">Descripcion</th>
                    <th className="p-2">Debe</th>
                    <th className="p-2">Haber</th>
                    <th className="p-2">Importe</th>
                    <th className="p-2">IVA</th>
                  </tr>
                </thead>
                <tbody>
                  {ledger.map((entry, idx) => (
                    <tr key={idx} className="border-t">
                      <td className="p-2">{entry.date}</td>
                      <td className="p-2">{entry.description}</td>
                      <td className="p-2">{entry.debit_account}</td>
                      <td className="p-2">{entry.credit_account}</td>
                      <td className="p-2">{entry.amount}</td>
                      <td className="p-2">{entry.vat}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Reports;
